// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__3Uj_B","error":"Textarea_error__7AGcG","readonly":"Textarea_readonly__zgaY1","disabled":"Textarea_disabled__1Ev3D"};